import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, Event as NavigationEvent } from '@angular/router';
import { Subscription }   from 'rxjs/Subscription';

import { CookieService } from '../../../providers/cookie.service';


export class CookiebarComponent implements OnInit {
	public showDisclaimer: boolean = false;
	public cookieAgreementName: string = 'hackajob_app_cookie_agreement';

	private routerSubscription: Subscription;

	constructor(
		private router: Router,
		private cookieService: CookieService) { }

	public ngOnInit() {
		this.watchRoute();
	}

	public closeDisclaimer(): void {
		this.showDisclaimer = false;

		let cookieData = this.cookieService.get(this.cookieAgreementName);
		cookieData = true;
		this.cookieService.set(cookieData, this.cookieAgreementName);

		this.unsubscribeRouterWatch();
	}

	private checkDisclaimer() {
		let cookieData = this.cookieService.get(this.cookieAgreementName);
		this.showDisclaimer = !cookieData;

		if (!this.showDisclaimer) {
			this.unsubscribeRouterWatch();
		}
	}

	private watchRoute(): void {
		this.routerSubscription = this.router.events.subscribe((event: NavigationEvent) => {
			if (event instanceof NavigationStart) {
				if (event.url.indexOf('/hack') !== -1) {
					this.showDisclaimer = false;
					return;
				}

				this.checkDisclaimer();
			}
		});
	}

	private unsubscribeRouterWatch(): void {
		if (this.routerSubscription) {
			this.routerSubscription.unsubscribe();
		}
	}
static ctorParameters() { return [ { type: Router }, { type: CookieService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/cookiebar/cookiebar.component.ts